import "@/i18n/config";
import React, { useEffect, useState } from "react";

import {
  getCommunityMemberProfiles,
  updateFocus,
} from "@/client_app/components/CommunityMemberDetails/services/FetchAPIService";
import { PrimaryButton } from "@/ui/buttons";

interface Props {
  positionId: string;
  inAdmin?: boolean;
}

export function Focus(props: Props) {
  const { positionId, inAdmin } = props;
  const [areasOfFocus, setAreasOfFocus] = useState<string>();
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    if (positionId) {
      getCommunityMemberProfiles(positionId, inAdmin)
        .then((response) => response.json())
        .then((data) => {
          setAreasOfFocus(data.areas_of_focus);
        });
    }
  }, [positionId]);

  const handleOnChange = (event) => {
    setAreasOfFocus(event.target.value);
    setUpdating(true);
  };

  const saveFocus = () => {
    updateFocus(positionId, areasOfFocus, inAdmin).then(() =>
      setUpdating(false)
    );
  };

  return (
    <div className='p-5 m-0 max-w-[800px]'>
      <p className='mb-5'>
        <strong>Current Areas of Focus</strong>
      </p>
      <textarea
        value={areasOfFocus}
        readOnly={inAdmin}
        onChange={handleOnChange}
        rows={10}
        cols={50}
        placeholder='Do not have info from the job, you can put it here...'
        className='w-full p-3 border-neutral-300 border rounded-lg'
      />
      {!inAdmin && (
        <div className='float-right'>
          <PrimaryButton
            label='Update'
            disabled={!updating}
            onClick={saveFocus}
          />
        </div>
      )}
    </div>
  );
}
